import {
  AdminLoginPostReqDTO,
  AdminLoginPostResDTO,
} from "../api/admin-dto.js";

/**
 * Admin 모델 정의
 * 프론트엔드에서 사용할 Admin 타입
 */
export interface AdminLoginData {
  username: string;
  password: string;
}

export interface AdminLoginResponse {
  success: boolean;
  token?: string;
  message: string;
  user?: {
    id: string;
    username: string;
  };
}

/**
 * DTO를 Admin 모델로 변환하는 함수
 */
export const toAdminLoginData = (dto: AdminLoginPostReqDTO): AdminLoginData => {
  return {
    username: dto.username,
    password: dto.password,
  };
};

export const toAdminLoginResponse = (
  dto: AdminLoginPostResDTO,
): AdminLoginResponse => {
  return {
    success: dto.success,
    token: dto.token,
    message: dto.message,
    user: dto.user,
  };
};

/**
 * Admin 모델을 POST 요청 DTO로 변환하는 함수
 */
export const toAdminLoginPostReqDTO = (
  admin: AdminLoginData,
): AdminLoginPostReqDTO => {
  return {
    username: admin.username,
    password: admin.password,
  };
};
